import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { memo } from 'react';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { VscError } from 'react-icons/vsc';
import { useSnapshot } from 'valtio';
import { fill_horizontal_all_center } from '~/modules/AppLayout/FlexGridCss';
import { fr_instrument } from '~/modules/SDK/FrInstrument/FrInstrument';
import { useSymbolWatchList } from '~/modules/WatchList/useSymbolWatchList';
import { store } from '~/pages/heineken_template/_private/store';
const classes = {
    Root: styled.div `
    ${fill_horizontal_all_center}
    background-color: ${props => props.isJoined === true ? buttonClasses.hadJoined : buttonClasses.notJoined};
    gap: 4px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
    ${options => {
        const long = options.variant === 'long' &&
            css `
          background-color: #994444;
        `;
        const short = options.variant === 'short' &&
            css `
          background-color: #449944;
        `;
        return css([long, short]);
    }}
  `,
};
const WatchSymbolToggleForStocknerve = memo(function WatchSymbolToggleForStocknerve(props) {
    const { state: { symbolListArray: watchList }, acts, } = useSymbolWatchList(props.groupName);
    const symbolString = useSnapshot(store.charting).symbol;
    //是否為指數期貨
    const isIndexFutures = symbolString.includes('TX');
    const getUnderlying = fr_instrument.getUnderlying(symbolString.slice(0, 3))?.symbol;
    //如果現在圖表商品是股期代號 自動轉成現貨代號
    //如果是指數期貨則不轉換 因為TX-1會被轉成TSEA
    const stockFuturesString = !isIndexFutures && getUnderlying ? getUnderlying : symbolString ?? symbolString;
    const describeText = props.describeText ?? '';
    //現在商品是否是有股期
    //返回true則目前圖表是現貨
    //反回false則可能沒股期或是圖表是股期
    const isIndexState = fr_instrument.getFutures(symbolString).default?.symbol ? true : false;
    //最終判斷加入: 原本商品 || 股期轉換現貨的代碼
    const addSymbol = isIndexState ? symbolString : stockFuturesString;
    const hadSymbol = watchList?.includes(addSymbol);
    const icon = hadSymbol ? <VscError /> : <BsFillPlusCircleFill />;
    return (<classes.Root isJoined={hadSymbol} className={props.className} onClick={event => {
            if (hadSymbol) {
                acts.removeSymbol(addSymbol);
            }
            if (!hadSymbol) {
                acts.addSymbol(addSymbol, props.maxSize ?? 30);
            }
        }}>
      {icon}
      {addSymbol}
      {hadSymbol ? '移除' + describeText + '自選' : '加入' + describeText + '自選'}
    </classes.Root>);
});
const buttonClasses = {
    hadJoined: '#994444',
    notJoined: '#448899',
};
export default {
    display: WatchSymbolToggleForStocknerve,
    classes,
    buttonClasses,
};
